import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, forwardRef, HostBinding, Input, OnDestroy, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { ProjectBonus, ProjectBonusFilters } from 'src/app/commons/models/project-bonus.model';

export const PROJECT_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => ProjectBonusesFieldComponent),
};

@Component({
  selector: "app-project-bonuses-field",
  templateUrl: "./project-bonuses-field.component.html",
  styleUrls: ["./project-bonuses-field.component.scss"],
  providers: [PROJECT_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class ProjectBonusesFieldComponent
  implements OnDestroy, ControlValueAccessor, MatFormFieldControl<ProjectBonus[]> {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  private unsubscribe$ = new Subject<void>();

  private _value: ProjectBonus[] = [];
  private _disabled = false;
  openEdit: boolean;
  currentProjectBonusIndex: number;

  private _required = false;

  @Input()
  isBonusInPercentage: boolean;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "project-bonus-selection-field";
  autofilled?: boolean;
  projectBonusAriaDescribedBy?: string;

  @Input()
  projectBonuslFilters: ProjectBonusFilters;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
  ) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() { }

  get currentProjectBonus(): ProjectBonus {
    if (this.currentProjectBonusIndex >= 0)
      return this.value.at(this.currentProjectBonusIndex);
    return null;
  }

  open() {
    this.openEdit = true;
  };

  close() {
    this.openEdit = false;
  }

  addProjectBonus() {
    this.currentProjectBonusIndex = -1;
    this.open();
  }

  editProjectBonus(index: number) {
    this.currentProjectBonusIndex = index;
    this.open();
  }

  save(projectBonus: ProjectBonus) {
    if (this.currentProjectBonusIndex >= 0) {
      this._value[this.currentProjectBonusIndex] = projectBonus;
      this.currentProjectBonusIndex = -1;
    } else {
      this._value.push(projectBonus);
    }

    this.notifyValueChange();
  }

  removeProjectBonus(index: number) {
    if (this.currentProjectBonusIndex === index) {
      this.currentProjectBonusIndex = -1;
      this.close();
    }

    this.value.splice(index, 1);
    this.notifyValueChange();
  }

  stateChanges = new Subject<void>();
  id: string;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {

  }

  onContainerClick(event: MouseEvent): void {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  @Input()
  set value(value: ProjectBonus[]) {
    this._value = value;
    this.stateChanges.next();
  }

  get value(): ProjectBonus[] {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: ProjectBonus[]): void {
    this.value = [];
    if (obj) {
      this.value.push(...obj);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
